/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import { useUserAuth } from "../../context/UserContext";

import AiAssistant from "../../components/AiAssistant/AiAssistant.js";

const GetStarted = () => {


  const mainRef = useRef(null);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainRef.current.scrollTop = 0;
  }, []);



  return (
    <>
      <DemoNavbar />
      <main ref={mainRef}>
        <section className="bordersection section-shaped section-lg h-100vh">
          <div className="shape  shape-style-8 shape-default shape-codenec2-color">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="container-lg  ">
            <Row className="justify-content-center ">
              {/* <Col lg="0">
                
              </Col> */}
              <Col lg="12" className=" ">
                <div className=" " >
                  <AiAssistant embedded />
                </div>

              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <MainFooter />
    </>
  );
};

export default GetStarted;
